import { render, staticRenderFns } from "./UsersFilters.vue?vue&type=template&id=5824e393&scoped=true&"
import script from "./UsersFilters.vue?vue&type=script&lang=js&"
export * from "./UsersFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5824e393",
  null
  
)

export default component.exports